<template>
  <fragment>


    <form action="" id="payment-form">
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">Full Name</label>
            <div class="control">
              <input class="input" v-model="formData.name" vrules="required" type="text"
                     placeholder="Full Name">
            </div>
            <div class="help is-danger vrule" rule="required">
              This field is required.
            </div>
          </div>

        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">Credit Card Number</label>
            <div class="control">
              <input type="hidden" vrules="required" v-model="cardStatus.number">
              <div id="card"></div>
            </div>
            <div class="help is-danger vrule" rule="required">
              This field is required.
            </div>

          </div>

        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">Expiry Date</label>
            <div class="control">
              <div id="card-expiry"></div>
              <input type="hidden" vrules="required" v-model="cardStatus.exp">
            </div>
            <div class="help is-danger vrule" rule="required">
              This field is required.
            </div>
          </div>

        </div>
        <div class="column">
          <div class="field">
            <label class="label">CVC Code</label>
            <div class="control">
              <div id="card-cvc"></div>
              <input type="hidden" vrules="required" v-model="cardStatus.cvc">
            </div>
            <div class="help is-danger vrule" rule="required">
              This field is required.
            </div>
          </div>

        </div>
      </div>
      <div class="columns">
        <div class="column is-6">
          <div class="field">
            <label class="label">Country</label>
            <div class="control block-select-fullwidth">
              <div class="select">
                <select v-model="formData.country">
                  <option :value="country.Code" v-for="country in COUNTRIES">
                    {{ country.Name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="help is-danger vrule" rule="required">
              This field is required.
            </div>
          </div>

        </div>
        <div class="column is-6" v-if="formData.Country === 'US'">
          <div class="field">
            <label class="label">State</label>
            <div class="control">
              <input class="input" v-model="formData.state" vrules="required" type="text"
                     placeholder="State">
            </div>
            <div class="help is-danger vrule" rule="required">
              This field is required.
            </div>
          </div>

        </div>
      </div>
      <div class="columns">
        <div class="column is-half">
          <div class="field">
            <label class="label">Postal Code</label>
            <div class="control">
              <input class="input" v-model="formData.postal_code" vrules="required" type="text"
                     placeholder="Postal Code">
            </div>
            <div class="help is-danger vrule" rule="required">
              This field is required.
            </div>
          </div>
        </div>

      </div>
    </form>
    <!-- <div class="columns">
        <div class="column is-half">
             <button @click.prevent="createPaymentMethod()">TEST</button>
        </div>

    </div> -->
  </fragment>
</template>
<script>
import {FalStripe} from "../../../shared/falconStripe";
import {PaymentAPI} from "../../../apis/PaymentAPI";
import {FormValidation} from "../../../shared/directives/formValidation";
import {COUNTRIES} from "@/modules/account/constants/countries";

export default {
  name: "PaymentMethod",
  props: [],
  data() {
    return {
      COUNTRIES,
      formData: {},
      cardStatus: {
        number: '',
        cvc: '',
        exp: '',
      },
      stripe: FalStripe(),
      cardNumber: null
    }
  },
  async mounted() {
    const elements = this.stripe.elements();
    this.formValidation = new FormValidation('#payment-form')

    this.cardNumber = elements.create('cardNumber', {
      showIcon: true,
      classes: {
        base: 'payment-input'
      }
    });

    // var cardElement = elements.getElement('card');
    this.cardNumber.mount('#card');
    this.cardNumber.on('change', async (event) => {
      if (event.complete) {
        this.cardStatus.number = '1';
      } else if (event.error) {
        this.cardStatus.number = '';
        this.$toasted.show(event.error.message, {
          theme: "bubble",
          position: "top-center",
          duration: 4000,
          className: 'falcon-toasted',
        });
      }
    });

    var cardExpiry = elements.create('cardExpiry', {
      classes: {
        base: 'payment-input'
      }
    });
    cardExpiry.mount('#card-expiry');
    cardExpiry.on('change', async (event) => {
      if (event.complete) {
        this.cardStatus.exp = '1';
        // enable payment button
      } else if (event.error) {
        this.cardStatus.exp = '';
        this.$toasted.show(event.error.message, {
          theme: "bubble",
          position: "top-center",
          duration: 4000,
          className: 'falcon-toasted',
        });
      }
    });

    let cardCvc = elements.create('cardCvc', {
      classes: {
        base: 'payment-input'
      }
    });
    cardCvc.mount('#card-cvc');
    cardCvc.on('change', async (event) => {
      if (event.complete) {
        this.cardStatus.cvc = '1';
      } else if (event.error) {
        this.cardStatus.cvc = '';
        this.$toasted.show(event.error.message, {
          theme: "bubble",
          position: "top-center",
          duration: 4000,
          className: 'falcon-toasted',
        });
      }
    });
  },
  methods: {
    async createPaymentMethod() {

      if (!this.formValidation.runAllValidations()) {
        this.loading = false;
        return false;
      }


      let paymentMethodResp = await this.stripe.createPaymentMethod({
        type: 'card',
        card: this.cardNumber,
        billing_details: {
          name: this.formData.name,
          address: {
            country: this.formData.country,
            state: this.formData.state,
            postal_code: this.formData.postal_code,
          },
        }
      });
      if (paymentMethodResp.error) {
        this.loading = false;
        this.$toasted.show(paymentMethodResp.error.message, {
          theme: "bubble",
          position: "top-center",
          duration: 4000,
          className: 'falcon-toasted',
        });
        return false;
      } else {
        let resp = await PaymentAPI.updatePaymentMethods(paymentMethodResp.paymentMethod.id, this.formData)
        if (resp.httpStatus !== 200) {
          this.$toasted.show(resp.message, {
            theme: "bubble",
            position: "top-center",
            duration: 4000,
            className: 'falcon-toasted',
          });
          return false;
        }
        resp.id = paymentMethodResp.paymentMethod.id;
        SFAnalytics.track('Payment Created', {})
        return resp;
      }
    },

  }
}
</script>
